import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

@Directive({
  selector: '[appHideAccess]'
})
export class HideAccessDirective {
  private actualActiveAccess!: boolean;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private stateManagementService: StateManagementService
  ) {
   }

  @Input() set appHideAccess(condition: boolean | undefined) {
    const commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    // If condition is not provided, get it from the local service state
    this.actualActiveAccess = condition !== undefined ? condition : commonAccessControl;
    this.updateView();
  }
  
  private updateView() {
    if (this.actualActiveAccess) {
      // If the condition is true, add the template to the DOM
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      // If the condition is false, remove the template from the DOM
      this.viewContainer.clear();
    }
  }

}
